
import { Component, Vue, Prop, Emit } from "vue-property-decorator"

@Component({
	components: {
	}
})
export default class SearchDropDown extends Vue {
	@Prop({ type: Array, default: () => [] })
	options!: any[]

	@Prop({ type: String, default: "label" })
	label!: string

	@Prop({ type: String, default: "" })
	text!: string

	private searchTerm: string = ""

	get filteredItems (): any[] {
		const lowerSearch = this.searchTerm.toLowerCase()
		return this.options.filter(o => (o[this.label] as string).toLowerCase().includes(lowerSearch))
	}
}
